export * from './abschnitte-sortiert.interface';
